import { z } from "zod";
import { nameSchema, descriptionSchema } from "./common.js";
/**
 * Documents (D-23): PDFs, images and links an org admin publishes to the field.
 *
 * Deliberately a module of its own rather than a field on `Product`. A
 * catalogue outlives any single product, is replaced as a whole file rather
 * than edited row by row, and needs to reach karigars — who hold no other part
 * of the console — without granting them the products page to do it.
 *
 * The PDF itself never crosses this contract as a DTO field: the browser is
 * only ever given the proxied `/org/documents/:id/file` path, so reading a
 * document always passes the permission check.
 */
export const DOCUMENT_STATUSES = ["active", "inactive"];
export const DOCUMENT_KINDS = ["pdf", "image", "link"];
const titleSchema = nameSchema.max(120, "Keep the title under 120 characters");
/** What the admin publishes. Older PDF clients may omit `kind`. */
export const createDocumentSchema = z.object({
    title: titleSchema,
    description: descriptionSchema.optional(),
    kind: z.enum(DOCUMENT_KINDS).default("pdf"),
    /** A base64 `data:` URL for PDFs and images. */
    dataUrl: z.string().trim().optional(),
    linkUrl: z.string().trim().url("Enter a valid link").refine((url) => /^https?:\/\//i.test(url), "Use an http or https link").optional(),
}).superRefine((input, ctx) => {
    if (input.kind === "link" && !input.linkUrl) {
        ctx.addIssue({ code: "custom", path: ["linkUrl"], message: "Enter a link" });
    }
    if (input.kind !== "link" && !input.dataUrl) {
        ctx.addIssue({ code: "custom", path: ["dataUrl"], message: "Choose a file to upload" });
    }
});
export const updateDocumentSchema = z.object({
    title: titleSchema.optional(),
    description: descriptionSchema.optional(),
    status: z.enum(DOCUMENT_STATUSES).optional(),
});
//# sourceMappingURL=documents.js.map